import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./D2DistanceTravelled.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, DCommonTableLabel } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const D2DistanceTravelled = forwardRef(({ D2DistanceTravelledData,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (D2DistanceTravelledData) {
            reset(prev => ({ ...prev, d2: D2DistanceTravelledData }));
        }
    }, [D2DistanceTravelledData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("d2");
        const payload = {
            ...DCommonTableLabel.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const D2DistanceTravelled = await callApi({
                method: "POST",
                url: API_ROUTES.D2(vesselMstId),
                data: payload,
            });
            if (D2DistanceTravelled?.isSuccess) {
                emitToasterMsg("success", "Table D.2", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, d2: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table D.2", D2DistanceTravelled?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table D.2", error?.errorMessage);
        }
    };

    return (
        <div className="d2-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of method</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Method to treat data gaps regarding distance travelled
                    </h6>
                </MDBCol>
            </MDBRow>

            {DCommonTableLabel.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`d2.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`d2_${name}`}
                                    className="textarea-resize"
                                    value={field.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="d2_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                    disabled={!isDirty}
                >
                    Save
                </Button>
            </div>
        </div>
    );
});

export default D2DistanceTravelled;
